module.exports = __webpack_public_path__ + "static/assets/550f547c3939352cf7cc0e6ae2594aa3.jpg";